import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import Table from "../adminDashboard/Table.js";
import Loader from "../../Loader.jsx";
import { toast, ToastContainer } from "mdbreact";
import DateTimePicker from "./DateTimePicker";
import {
  setReglas,
  delReglas,
  getCookie,
  getValoresXDominio,
  decodeToken,
  find,
  getConsultorios,
  getReglas,
} from "../../functions.js";

import ReactExport from "react-export-excel-xlsx-fix";
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

var fecNum = Date.now();
var fecNum2 = Date.now() + 1;

var f = new Date();
var fromDate = new Date();
fromDate.setDate(f.getDate() - 3);

var mes =
  f.getUTCMonth() + 1 < 10 ? "0" + (f.getUTCMonth() + 1) : f.getUTCMonth() + 1;
var dia = f.getUTCDate() < 10 ? "0" + f.getUTCDate() : f.getUTCDate();
var date_label = f.getUTCFullYear() + "." + mes + "." + dia;

class ManageRules extends Component {
  constructor(props) {
    super(props);
    this.state = {
      key: 1,
      bookings: [],
      action: "create",
      token_to_delete: "",
      date_label: date_label,
      loaded: false,
      id: 0,
      invalidForm: false,
      customerDocumentId: 0,
      RadioReservationType: 0,
      customerName: "",
      customerId: 0,
      redirect: false,
      productId: 0,
      birthDate: null,
      bookingName: "",
      estado: "ACTIVO",
      diaSemana: -1,
      lockInputs: false,
      buttonLabel: "Crear Regla",
      products: [],
      id_consultorio: 0,
      consultorios: [],
      reservas: [],
      titulo: (
        <>
          {" "}
          <i className="fas fa-plus" /> Nueva Regla{" "}
        </>
      ),
      servicios: [],
      canales: [],
      reglas: [],
      canal: "",
      etiqueta1n: "Minuto",
      etiqueta2n: "Hora",
      etiqueta1a: "Fecha final",
      etiqueta2a: "Hora",
      validations: {
        regla: false,
        id_consultorio: false,
        tipo: false,
        estado: false,
        fechaFin: false,
        fechaIni: false,
        diaSemana: false,
        horaIni1: false,
        horaIni2: false,
        horaFin1: false,
        horaFin2: false,
      },

      disableds: {
        diaSemana: false,
        fechaFin: false,
        fechaIni: false,
        horaIni1: false,
        horaIni2: false,
        horaFin1: false,
        horaFin2: false,
      },
      tableData: {
        columns: [
          {
            dataIndex: "id",
            title: "Action",
            render: (text, record) => (
              <>
                <div style={{ width: 70 }}>
                  <button
                    className="btn btn-sm btn-info"
                    id={record.id_regla}
                    name="view"
                    onClick={this.editarRegla}
                    type="submit"
                  >
                    <i className="fas fa-edit" />
                  </button>

                  <button
                    className="btn btn-sm btn-danger"
                    id={record.id_regla}
                    name="view"
                    onClick={this.eliminarRegla}
                    type="submit"
                  >
                    <i className="fas fa-trash" />
                  </button>
                </div>
              </>
            ),
          },

          { dataIndex: "regla", title: "Nombre Regla" },
          { dataIndex: "consultorio", title: "Consultorio" },
          { dataIndex: "tipo", title: "Tipo de Regla" },
          { dataIndex: "fechaIni", title: "Fecha de inicio" },
          { dataIndex: "fechaFin", title: "Fecha final" },
          { dataIndex: "horaIni", title: "Hora de Inicio" },
          { dataIndex: "horaFin", title: "Hora Final" },
          { dataIndex: "diaSemana", title: "Dia de la semana" },
          { dataIndex: "estado", title: "Estado" },
        ],
        rows: [],
      },

      tipos: [
        { value: "RANGODIAHORA", text: "Rango de días y horas" },
        { value: "DIA", text: "Día específico" },
        { value: "DIASEMANA", text: "Día de la semana" },
        { value: "HORASEMANA", text: "Hora de la semana" },
        { value: "HORADIASEMANA", text: "Hora de un día de la semana" },
        { value: "EXCEPCIONHORARIO", text: "Horario extendido" },
      ],

      estados: [
        { value: "ACTIVO", text: "ACTIVO" },
        { value: "BLOQUEADO", text: "BLOQUEADO" },
      ],
      tipo: "RANGODIAHORA",
      tipo_pago: "",

      servicio: "",
      productsNV: [],
      customerAge: 0,
      validityProduct: "",
      productName: "",
      modal1: false,

      regla: "",
      horaIni1: "-",
      horaIni2: "-",
      horaFin1: "-",
      horaFin2: "-",
      etiqueta: "",

      horas: [],
      minutos: [],

      fechaIni: fromDate,
      fechaFin: new Date(),
      /*
      etiqueta1n: "Minuto",
      etiqueta2n: "Hora",
      etiqueta1a: "Fecha final",
      etiqueta2a: "Hora",
      */
    };
    this.handleSelect = this.handleSelect.bind(this);
  }

  editarRegla = async (event) => {
    let id = event.target.id;
    if (id === "") {
      id = event.target.parentNode.id;
    }

    let tipo = "";
    let pos = find(this.state.reglas, id, "id_regla");
    let data = this.state.reglas[pos];
    console.log("DATA", data);
    for (let i in Object.keys(data)) {
      let field = Object.keys(data)[i];

      if (data[field] || data[field] === 0) {
        if (field === "fechaIni" || field === "fechaFin") {
          let fechaDate = new Date(data[field]);
          this.setState({
            [field]: fechaDate,
          });
          console.log(fechaDate);
        } else if (field === "horaIni" || field === "horaFin") {
          let hora = data[field].split(":");
          if (hora.length > 1) {
            this.setState({
              [field + "1"]: hora[0],
              [field + "2"]: hora[1],
            });
          } else {
            this.setState({
              [field + "1"]: "-",
              [field + "2"]: "-",
            });
          }
        } else if (field === "tipo") {
          tipo = data[field];
        } else {
          this.setState({
            [field]: data[field],
          });
        }
      } else {
        //console.log(field + " no hay", data[field]);
      }
    }

    this.changeHandler({ target: { name: "tipo", value: tipo } });

    this.setState({
      //validations: validations,
      action: "edit",
      buttonLabel: "Editar Regla",
      lockInputs: true,
      id: id,
      titulo: (
        <>
          {" "}
          <i className="fas fa-edit" />
          Editar Regla{" "}
        </>
      ),
      invalidForm: false,
    });
  };

  clearData = async (event) => {
    let validations = {};
    let titulo = (
      <>
        {" "}
        <i className="fas fa-plus" /> Nueva Regla{" "}
      </>
    );
    let tipo = "RANGODIAHORA";

    this.setState({
      validations: validations,
      action: "create",
      buttonLabel: "Crear Regla",
      lockInputs: false,
      titulo: titulo,

      id: 0,
      regla: "",

      horaIni1: "-",
      horaIni2: "-",
      horaFin1: "-",
      horaFin2: "-",
      etiqueta: "1",

      tipo: tipo,
      fechaIni: new Date(),
      fechaFin: new Date(),
      id_consultorio: 0,
      /*
      etiqueta1n: "Minuto",
      etiqueta2n: "Hora",
      etiqueta1a: "Fecha final",
      etiqueta2a: "Hora",
      */
      //invalidForm:true,
    });

    this.changeHandler({ target: { name: "tipo", value: tipo } });
  };

  eliminarRegla = async (event) => {
    //console.log(this.state.action)
    //this.setState({ ...this.state, isExecuting: true });
    let id = event.target.id;
    if (id === "") {
      id = event.target.parentNode.id;
    }

    let pos = find(this.state.reglas, id, "id_regla");
    let data = this.state.reglas[pos];

    if (data.DELETE_DATE) {
      toast.error("La regla ya está inactiva", { closeButton: true });
    } else {
      let formData = {
        id: id,
        username: this.state.username,
      };
      var respI = await delReglas(formData);

      if (respI.success) {
        var resp = await getReglas();

        const tableData = this.state.tableData;
        tableData.rows = resp.reglas ? resp.reglas : [];

        this.setState({
          ...this.state,
          isExecuting: false,
          reglas: resp.reglas,
        });
        this.clearData();
        toast.success("Se actualizó el estado a inactivo", {
          closeButton: true,
        });
      } else {
        toast.error(respI.messsage, { closeButton: true });
        this.setState({ ...this.state, isExecuting: false });
      }
    }
  };

  saveData = async (event) => {
    //console.log(this.state.action)

    let data = {
      regla: false,
      id_consultorio: false,
      tipo: false,

      estado: false,
      fechaFin: false,
      fechaIni: false,
      diaSemana: false,
      horaIni1: false,
      horaIni2: false,
      horaFin1: false,
      horaFin2: false,
    };

    let formData = {
      id: this.state.id,
      username: this.state.userInfo.id,
      action: this.state.action,
    };

    var isValid = true;
    for (let i in Object.keys(data)) {
      let field = Object.keys(data)[i];
      //	console.log(field, this.state[field])

      //console.log(field)

      if (this.state[field] === "") {
        data[field] = true;
        isValid = false;
      } else {
        if (field === "tipo") {
          let t = this.state[field];
          if (t.indexOf("HORA") >= 0) {
            if (this.state.horaFin1 === "-") {
              isValid = false;
              data["horaFin1"] = true;
            }
            if (this.state.horaFin2 === "-") {
              isValid = false;
              data["horaFin2"] = true;
            }
            if (this.state.horaIni1 === "-") {
              isValid = false;
              data["horaIni1"] = true;
            }
            if (this.state.horaIni2 === "-") {
              isValid = false;
              data["horaIni2"] = true;
            }
          }
        }

        if (field === "fechaIni") {
          if (
            this.state.tipo === "RANGODIAHORA" ||
            this.state.tipo === "DIA" ||
            this.state.tipo === "EXCEPCIONHORARIO"
          ) {
            let fechaString = this.state[field].toISOString().slice(0, 10);
            formData[field] = fechaString;
          } else {
            formData[field] = "-";
          }
        } else if (field === "fechaFin") {
          if (
            this.state.tipo === "RANGODIAHORA" ||
            this.state.tipo === "EXCEPCIONHORARIO"
          ) {
            let fechaString = this.state[field].toISOString().slice(0, 10);
            formData[field] = fechaString;
          } else {
            formData[field] = "-";
          }
        } else {
          formData[field] = this.state[field];
        }
      }
    }
    if (this.state.action === "create") {
    }

    if (isValid) {
      formData["horaIni"] = this.state.horaIni1 + this.state.horaIni2;
      formData["horaFin"] = this.state.horaFin1 + this.state.horaFin2;

      if (formData["horaIni"] === "--") {
        formData["horaIni"] = "-";
      } else {
        formData["horaIni"] = this.state.horaIni1 + ":" + this.state.horaIni2;
      }

      if (formData["horaFin"] === "--") {
        formData["horaFin"] = "-";
      } else {
        formData["horaFin"] = this.state.horaFin1 + ":" + this.state.horaFin2;
      }
      formData["username"] = this.state.username;

      this.setState({ ...this.state, isExecuting: true, reservas: [] });

      var respI = await setReglas(formData);
      console.log(respI);

      if (respI.success) {
        var resp = await getReglas();

        const tableData = this.state.tableData;
        tableData.rows = resp.reglas ? resp.reglas : [];

        this.setState({
          ...this.state,
          isExecuting: false,
          reglas: resp.reglas,
        });
        this.clearData();
        toast.success("Datos registrados correctamente", { closeButton: true });
      } else {
        console.log("mal");

        if (respI.reservas) {
          if (respI.reservas.length > 0) {
            this.setState({ ...this.state, reservas: respI.reservas });
          }
        }

        toast.error(respI.message, { closeButton: true });
        this.setState({ ...this.state, isExecuting: false });
      }
      //
    } else {
      this.setState({
        validations: data,
      });
    }
  };

  changeHandler = async (event) => {
    let value = event.target.value;
    let validations = this.state.validations;

    if (event.target.name === "tipo") {
      let disableds = {
        diaSemana: false,
        fechaFin: false,
        fechaIni: false,
        horaIni1: false,
        horaIni2: false,
        horaFin1: false,
        horaFin2: false,
      };
      let tipo = event.target.value;

      switch (tipo) {
        case "RANGODIAHORA":
          disableds["diaSemana"] = true;
          /*disableds["horaIni1"] = true;
          disableds["horaIni2"] = true;
          disableds["horaFin1"] = true;
          disableds["horaFin2"] = true;*/

          this.setState({
            diaSemana: "-1",
          });

          break;
        case "DIA":
          disableds["fechaFin"] = true;
          disableds["diaSemana"] = true;
          disableds["horaIni1"] = true;
          disableds["horaIni2"] = true;
          disableds["horaFin1"] = true;
          disableds["horaFin2"] = true;

          this.setState({
            diaSemana: "-1",
            horaIni1: "-",
            horaIni2: "-",
            horaFin1: "-",
            horaFin2: "-",
          });

          break;
        case "DIASEMANA":
          disableds[""] = true;
          disableds["fechaIni"] = true;
          disableds["fechaFin"] = true;
          disableds["horaIni1"] = true;
          disableds["horaIni2"] = true;
          disableds["horaFin1"] = true;
          disableds["horaFin2"] = true;

          this.setState({
            horaIni1: "-",
            horaIni2: "-",
            horaFin1: "-",
            horaFin2: "-",
          });

          break;
        case "HORASEMANA":
          disableds["fechaIni"] = true;
          disableds["fechaFin"] = true;
          disableds["diaSemana"] = true;

          this.setState({
            diaSemana: "-1",
          });

          break;
        case "HORADIASEMANA":
          disableds["fechaIni"] = true;
          disableds["fechaFin"] = true;
          break;

        case "EXCEPCIONHORARIO":
          disableds["diaSemana"] = true;
          this.setState({
            diaSemana: "-1",
          });
          break;

        default:
          break;
      }

      console.log(disableds, tipo);

      this.setState({
        disableds: disableds,
      });
    }

    validations[event.target.name] = value.length === 0;

    this.setState({
      [event.target.name]: value,
      validations: validations,
    });

    if (
      this.state.regla !== "" &&
      this.state.fechaFin !== "" &&
      this.state.horaIni1 !== "" &&
      this.state.horaIni2 !== "" &&
      //this.state.horaFin1 !=="" &&
      this.state.horaFin2 !== "" &&
      this.state.etiqueta !== ""
    ) {
      console.log("valid");
      /*
		if (this.state.action==="create"){
			if(this.state.contrasenia!==""){
				this.setState({
					invalidForm:false
					});
			}
		}else{
			this.setState({
				invalidForm:false
			 });
		}
		*/
    }
  };
  handleSelect(key) {
    this.setState({ key });
  }
  onClickRadioReservationType = (nr, serviceId, key) => () => {
    this.setState({
      ...this.state,
      RadioReservationType: nr,
    });
    const bookings = this.state.bookings;
    for (var i in bookings) {
      if (bookings[i].id_servicio === serviceId) {
        bookings[i].llaves[key].serviceType = nr;
      }
    }
  };

  componentDidMount = async () => {
    this.setState({ isExecuting: true });
    let token = getCookie("tokenINNOVA2");

    let esAdmin = true;
    var _resp;
    if (!token) {
      esAdmin = false;
    } else {
      _resp = await decodeToken(token);
      if (_resp.datos.rol !== "Administrador") {
        console.log("no permitido");
        esAdmin = false;
      }
    }

    if (!esAdmin) {
      this.setState({ redirect: true, isExecuting: false });
    } else {
      let respCs = await getConsultorios();

      let username = getCookie("nombreUsuarioINNOVA2");

      let resp = await getReglas();
      console.log("r", resp, respCs);
      var userInfo = _resp.datos;
      this.setState({ userInfo: userInfo, username: username });

      var canal = userInfo.canal;
      var canales = [];

      const tableData = this.state.tableData;
      tableData.rows = resp.reglas ? resp.reglas : [];

      var respC = await getValoresXDominio("canales");

      var horas = [];

      horas.push({ text: "-", value: "-" });
      for (let i = 0; i < 24; i++) {
        var hora = ("0" + i).slice(-2); // Agrega un cero delante si es necesario
        horas.push({ text: hora, value: hora });
      }
      var minutos = [];
      minutos.push({ text: "-", value: "-" });
      for (let i = 0; i < 60; i += 5) {
        var minuto = ("0" + i).slice(-2); // Agrega un cero delante si es necesario
        minutos.push({ text: minuto, value: minuto });
      }

      this.changeHandler({ target: { name: "tipo", value: "RANGODIAHORA" } });
      this.setState({
        ...this.state,
        loaded: true,
        consultorios: respCs.consultorios,
        horas: horas,
        minutos: minutos,
        reglas: resp.reglas,
        canales: canales,
        canal: canal,
        //servicios: servicios,
        //servicio:servicio,
        isExecuting: false,
      });
    }
  };
  toggleM = (nr) => () => {
    this.setState({
      ["modal" + nr]: !this.state["modal" + nr],
    });
  };

  render() {
    return (
      <>
        {this.state.redirect ? <Redirect to={{ pathname: "/" }} /> : ""}

        <div>
          <div className="breadcrumb-bar">
            <div className="container-fluid">
              <div className="row align-items-center">
                <div className="col-md-12 col-12">
                  <nav aria-label="breadcrumb" className="page-breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to="/home">Inicio</Link>
                      </li>
                    </ol>
                  </nav>
                  <h2 className="breadcrumb-title">
                    Administraci&oacute;n de Reglas
                  </h2>
                </div>
              </div>
            </div>
          </div>
          <Loader idLoading={this.state.isExecuting} />

          <div className="content">
            <ToastContainer
              hideProgressBar={true}
              newestOnTop={false}
              position={"bottom-right"}
              autoClose={3000}
            />
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6 col-lg-5 col-xl-4 theiaStickySidebar">
                  <div className="row">
                    <div className="col-12">
                      <div className="col-12">
                        <span className="h3-responsive ">
                          {this.state.titulo}
                        </span>
                      </div>
                    </div>
                  </div>
                  <span className="or-line" />
                  <div className="row">
                    <div className="col-12">
                      <div className="form-group mini-margin card-label">
                        <label>Nombre Regla</label>
                        <input
                          name="regla"
                          disabled={this.state.lockInputs}
                          className={
                            "form-control " +
                            (this.state.validations.regla ? "is-invalid" : "")
                          }
                          type="text"
                          value={this.state.regla}
                          onChange={this.changeHandler}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-12">
                      <div className="form-group mini-margin card-label">
                        <label>Consultorios</label>
                        <select
                          className={
                            " browser-default custom-select form-control " +
                            (this.state.validations.id_consultorio
                              ? "is-invalid"
                              : "")
                          }
                          name="id_consultorio"
                          onChange={this.changeHandler}
                          defaultValue={this.state.id_consultorio}
                          value={this.state.id_consultorio}
                        >
                          {this.state.consultorios.map((item) => (
                            <option key={item.value} value={item.value}>
                              {item.text}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-12">
                      <div className="form-group mini-margin card-label">
                        <label> Tipo de Regla </label>
                        <select
                          className={
                            " browser-default custom-select form-control " +
                            (this.state.validations.tipo ? "is-invalid" : "")
                          }
                          name="tipo"
                          onChange={this.changeHandler}
                          defaultValue={this.state.tipo}
                          value={this.state.tipo}
                        >
                          {this.state.tipos.map((item) => (
                            <option key={item.value} value={item.value}>
                              {item.text}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group mini-margin card-label"></div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-6">
                      <div className="form-group mini-margin card-label">
                        <label>Fecha de inicio</label>
                        {this.state.disableds.fechaIni ? (
                          <input
                            name="fechaIni"
                            disabled={true}
                            className={
                              "form-control " +
                              (this.state.validations.fechaIni
                                ? "is-invalid"
                                : "")
                            }
                            type="text"
                            value={"-"}
                          />
                        ) : (
                          <DateTimePicker
                            date={
                              this.state.fechaIni
                                ? this.state.fechaIni
                                : new Date()
                            }
                            name="fechaIni"
                            label="fechaIni"
                            isUpdatable={true}
                            updateDate={this.changeHandler}
                          />
                        )}
                      </div>
                    </div>

                    <div className="col-6">
                      <div className="form-group mini-margin card-label">
                        <label>Fecha Final</label>
                        {this.state.disableds.fechaFin ? (
                          <input
                            name="fechaFin"
                            disabled={true}
                            className={
                              "form-control " +
                              (this.state.validations.fechaFin
                                ? "is-invalid"
                                : "")
                            }
                            type="text"
                            value={"-"}
                          />
                        ) : (
                          <DateTimePicker
                            date={
                              this.state.fechaFin
                                ? this.state.fechaFin
                                : new Date()
                            }
                            name="fechaFin"
                            label="fechaFin"
                            isUpdatable={true}
                            updateDate={this.changeHandler}
                          />
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-12">
                      <div className="form-group mini-margin card-label">
                        <label>Dia de la semana</label>
                        <select
                          name="diaSemana"
                          disabled={this.state.disableds.diaSemana}
                          className={
                            "form-control " +
                            (this.state.validations.diaSemana
                              ? "is-invalid"
                              : "")
                          }
                          onChange={this.changeHandler}
                          value={this.state.diaSemana}
                          defaultValue={this.state.diaSemana}
                        >
                          <option value={"-1"}>Todos los días</option>
                          <option value={"1"}>Lunes</option>
                          <option value={"2"}>Martes</option>
                          <option value={"3"}>Miércoles</option>
                          <option value={"4"}>Jueves</option>
                          <option value={"5"}>Viernes</option>
                          <option value={"6"}>Sábado</option>
                          <option value={"0"}>Domingo</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div
                      className="col-6"
                      style={{
                        paddingLeft: 20,
                        position: "relative",
                        top: 10,
                        fontSize: 18,
                      }}
                    >
                      Hora de inicio
                    </div>
                    <div
                      className="col-6"
                      style={{
                        paddingLeft: 20,
                        position: "relative",
                        top: 10,
                        fontSize: 18,
                      }}
                    >
                      Hora Final
                    </div>
                    <div className="col-3">
                      <div className="form-group mini-margin card-label">
                        <label>{this.state.etiqueta2n}</label>
                        <select
                          name="horaIni1"
                          disabled={this.state.disableds.horaIni1}
                          className={
                            " browser-default custom-select form-control " +
                            (this.state.validations.horaIni1
                              ? "is-invalid"
                              : "")
                          }
                          onChange={this.changeHandler}
                          value={this.state.horaIni1}
                          defaultValue={this.state.horaIni1}
                        >
                          {this.state.horas.map((item) => (
                            <option key={item.value} value={item.value}>
                              {item.text}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="form-group mini-margin card-label">
                        <label>{this.state.etiqueta1n}</label>
                        <select
                          name="horaIni2"
                          disabled={this.state.disableds.horaIni2}
                          className={
                            " browser-default custom-select form-control " +
                            (this.state.validations.horaIni2
                              ? "is-invalid"
                              : "")
                          }
                          onChange={this.changeHandler}
                          value={this.state.horaIni2}
                          defaultValue={this.state.horaIni2}
                        >
                          <option value={"-"}>-</option>
                          <option value={"00"}>00</option>
                          <option value={"30"}>30</option>
                        </select>
                      </div>
                    </div>

                    <div className="col-3">
                      <div className="form-group mini-margin card-label">
                        <label>{this.state.etiqueta2a}</label>
                        <select
                          name="horaFin1"
                          disabled={this.state.disableds.horaFin1}
                          className={
                            " browser-default custom-select form-control " +
                            (this.state.validations.horaFin1
                              ? "is-invalid"
                              : "")
                          }
                          onChange={this.changeHandler}
                          value={this.state.horaFin1}
                          defaultValue={this.state.horaFin1}
                        >
                          {this.state.horas.map((item) => (
                            <option key={item.value} value={item.value}>
                              {item.text}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="form-group mini-margin card-label">
                        <label>Minuto</label>
                        <select
                          name="horaFin2"
                          disabled={this.state.disableds.horaFin2}
                          className={
                            " browser-default custom-select form-control " +
                            (this.state.validations.horaFin2
                              ? "is-invalid"
                              : "")
                          }
                          onChange={this.changeHandler}
                          value={this.state.horaFin2}
                          defaultValue={this.state.horaFin2}
                        >
                          <option value={"-"}>-</option>
                          <option value={"00"}>00</option>
                          <option value={"30"}>30</option>
                          <option value={"59"}>59</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="row mt-3 mb-3">
                    <div className="col-6">
                      <div className="form-group mini-margin card-label">
                        <button
                          className="btn btn-danger btn-block"
                          name="search"
                          onClick={this.clearData}
                          type="submit"
                        >
                          Limpiar Datos
                        </button>
                      </div>
                    </div>

                    <div className="col-6">
                      <div className="form-group mini-margin card-label">
                        <button
                          className="btn btn-primary btn-block"
                          name="search"
                          onClick={this.saveData}
                          disabled={this.state.invalidForm}
                          type="submit"
                        >
                          {this.state.buttonLabel}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div id="atenciones" className="col-md-6 col-lg-7 col-xl-8">
                  {this.state.reservas.length > 0 && (
                    <div
                      className=" alert alert-danger alert-dismissible fade show"
                      role="alert"
                    >
                      <div className="row mt-2 mb-2">
                        <div className="col-12">
                          <h4>
                            {" "}
                            ADVERTENCIA: EXISTEN RESERVAS DENTRO DEL PERIDO
                            SELECCIONADO
                          </h4>
                        </div>
                      </div>
                      {this.state.reservas.map((item) => (
                        <div className="row">
                          <div className="col-12">
                            RESERVA: {item.fecha + " " + item.hora} PACIENTE:{" "}
                            {item.paciente} (ID HORARIO:{item.id} )
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  <div className="card">
                    <div className="card-body pt-0">
                      <div
                        id="results"
                        className="col-12 col-lg-12 text-right mb-2 mt-3"
                        style={{ padding: 0 }}
                      >
                        <ExcelFile
                          filename={"export-ordenes." + this.state.date_label}
                          element={
                            <button
                              disabled={this.state.tableData.rows.length == 0}
                              type="button"
                              className="btn btn-sm btn-success"
                              name="set"
                            >
                              {" "}
                              Exportar
                            </button>
                          }
                        >
                          <ExcelSheet
                            data={this.state.tableData.rows}
                            name="ordenes"
                          >
                            <ExcelColumn label="Nombre Regla" value="regla" />
                            <ExcelColumn label="Tipo de Regla" value="tipo" />
                            <ExcelColumn
                              label="Fecha de inicio"
                              value="fechaIni"
                            />
                            <ExcelColumn
                              label="Apellido Materno"
                              value="fechaFin"
                            />
                            <ExcelColumn
                              label="Hora de inicio"
                              value="horaIni"
                            />
                            <ExcelColumn label="Fecha final" value="horaFin" />

                            <ExcelColumn
                              label="Dia de la semana"
                              value="diaSemana"
                            />
                            <ExcelColumn label="Estado" value="estado" />
                          </ExcelSheet>
                        </ExcelFile>
                      </div>

                      <Table tableData={this.state.tableData} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default ManageRules;
